import React, { useEffect } from 'react';
import './styles.scss';
import { Outlet } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import PageText from 'components/base/page-text';
import { apiService } from 'services/base.service';
import { STORAGE_KEYS } from 'utils/constants';
import Sidebar from 'components/sidebar';
import Header from 'components/header';
import CreateSaReferralCodeModal from 'components/modals/create-sa-referral-code';

const DashboardContent = () => {
  const {
    activeCokitchen,
    rightSection,
    isRightSectionWide,
    setCokitchens,
    showStudentAmbassadorModal,
    setShowStudentAmbassadorModal
  } = useDashboardContext();

  const fetchCokitchens = async () => {
    const res = await apiService.get('cokitchens', {
      isInternal: true
    });
    const data = res.data.data;
    localStorage.setItem(STORAGE_KEYS.COKITCHEN_LIST, JSON.stringify(data));
    setCokitchens(data);
  };

  useEffect(() => {
    fetchCokitchens();
  }, []);

  return (
    <div className='flex lg:pl-[260px]'>
      <div className='min-h-screen max-lg:hidden'>
        <Sidebar />
      </div>
      <div className='w-full flex flex-col min-h-screen'>
        <Header />
        {activeCokitchen?.id ? (
          <div className={`flex max-lg:flex-col ${rightSection ? 'lg:overflow-hidden' : ''}`}>
            <div className={`w-full ${rightSection ? 'overflow-y-auto' : ''}`}>
              <CreateSaReferralCodeModal
                isOpen={showStudentAmbassadorModal}
                onClose={() => setShowStudentAmbassadorModal(false)}
              />
              <Outlet />
            </div>
            {rightSection && (
              <div className={`right-section ${isRightSectionWide ? 'is-wide' : ''}`}>
                {rightSection}
              </div>
            )}
          </div>
        ) : (
          <PageText text='Loading co-kitchen data...' />
        )}
      </div>
    </div>
  );
};

export default DashboardContent;
